// ── Route adapter for the base product editor ───────────────────────
//
// The route /products/blanks/:blankId/* mounts this component. It picks
// between V1 (the current tabbed editor) and V2 (the unified shell)
// based on the `blankEditor.unified` flag, and leaves the specialty
// wizard redirect alone (that's handled downstream in BlankSettingsPage
// and will be unified in PR 2). Mounting the picker here keeps the
// route table dumb and the flag check in one place.

import React, { lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useFeatureFlag } from "../../helpers/featureFlags";
import { PageContentSkeleton } from "../../components/common/PageSkeleton";
import { chooseBlankEditor, UNIFIED_BLANK_EDITOR_FLAG } from "./unifiedEditor";

const V1 = lazy(() => import("./BlankSettingsPage"));
const V2 = lazy(() => import("./BlankSettingsPageV2"));

const Loader = () => (
  <div className="page-content">
    <PageContentSkeleton titleWidth="220px" blocks={2} />
  </div>
);

export default function BlankEditorRoute() {
  const unified = useFeatureFlag(UNIFIED_BLANK_EDITOR_FLAG);
  const { blankId } = useParams();
  const blank = useSelector(
    (state) => state?.blankProducts?.addedBlankProducts?.[blankId] || null
  );
  // Print blanks still redirect to the specialty wizard (handled by V1's
  // existing isRiverrSpecialtyBlank check). The flag only replaces the
  // apparel / 3D editor with V2.
  const useV2 = unified && chooseBlankEditor(blank) === "generic";
  const Editor = useV2 ? V2 : V1;
  return (
    <Suspense fallback={<Loader />}>
      <Editor />
    </Suspense>
  );
}
